import React, { useEffect } from "react";
import Game from "./Game";
import './Home.css'
import OpenRom from "./OpenRom";

const Home = ({rom, setRom}) => {
    const [games, setGames] = React.useState([]);
    useEffect(() => {
        fetch("./roms/roms.json",
        {
            headers:{
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }
        ).then(res => res.json()).then(data => {
            setGames(data["roms"]);
        });
    }, [])
    return (
    <div className = {"Home"}>
        <div className = "Home__Title">
            <h1> jsNES</h1>
        </div>
        <div className = {"Roms"}>
        {
            games.map(game => <Game key = {game["name"]} title={game["name"]} romPath={game["path"]} thumbnail ={game["img"]} description = {game["desc"]} rom = {rom} setRom = {setRom}/>)
        }
        <OpenRom rom={rom} setRom={setRom}/>
    </div>
    </div>
    
  );
}

export default Home;